import React, { useState } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

const DatePickerX = (props) => {
    // const [startDate, setStartDate] = useState(new Date());
    return (
        <DatePicker
            className={props.class}
            selected={props.startDate}
            onChange={date => props.setStartDate(date)}
            timeInputLabel="Time:"
            dateFormat="dd/MM/yyyy h:mm aa"
            showTimeInput
        />
    );
};

export default DatePickerX